import './style.scss'

interface IButtonProps {
  children: any;
  fillColor?: boolean;
  clx?: string;
  disabled?: boolean;
  onButtonClick?: () => void;
  type?: "button" | "submit" | "reset";
}
  
  const CustomButton = ({ clx = '', fillColor = true, onButtonClick, disabled, type, children }: IButtonProps) => {
        return (
          <button className={`custom-btn ${fillColor ? 'primary-btn' : 'secondary-btn'} ${disabled ? 'disabled-btn' : ''} ${clx} `}
            onClick={onButtonClick} disabled={disabled} type={type}>
           {children}
          </button>
        );
  };
  
  export default CustomButton;
  